<template>
  <div class="flex flex-col h-full min-h-0 bg-elev-panel-bg">
    <header class="flex items-center justify-between pl-4 py-2 pr-2">
      <h3 class="select-none text-fg-base-fg3 text-heading-sb-20-26 py-[7px]">
        {{ title }}
      </h3>
      <div class="flex items-center gap-2">
        <slot name="headerBtn" />
        <div
          v-if="showClose"
          class="cursor-pointer hover:bg-bg-base-bg4 rounded-8 p-2"
          data-test="sidebar-close"
          @click="closeSidebar"
        >
          <wui-icon
            name="closeRegularMdM"
            class="text-fg-base-fg10 h-6! w-6!"
          />
        </div>
      </div>
    </header>
    <div class="px-2 flex flex-1 min-h-0 flex-col">
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
import { WuiIcon } from '@wui/common-library'

import { useSidebar } from '@/shared/composables/use-sidebar'

const { closeSidebar } = useSidebar()

withDefaults(defineProps<{
  title: string
  showClose?: boolean
}>(), {
  showClose: true,
})
</script>
